export enum TransactionStatusEnum {
    New = 'new',
    Started = 'started',
    Approved = 'approved',
    Successful = 'successful',
    Cancelled = 'cancelled',
    Failed = 'failed',
}

export enum TransactionsEnum {
    Sale = 'sale',
    Purchase = 'purchase',
    PurchasePayout = 'purchase_payout',
    Credit = 'credit',
}

export enum PaymentProvidersEnum {
    PayNL = 'paynl',
    Mollie = 'mollie',
}

export enum PaymentMethodsNameEnum {
    iDeal = 'ideal',
    PayPal = 'paypal',
}

export enum PaymentMethodsEnum {
    PayPal = '138',
    iDeal = '10',
}
